import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconClockProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconClock: React.FC<IconClockProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Pending',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6v6l4 2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="12" cy="12" r="10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconClock;
